module.exports = __webpack_public_path__ + "static/media/club_badge.3bc6b5f7.svg";